import { render, staticRenderFns } from "./MobileWindow.vue?vue&type=template&id=0a13432d"
import script from "./MobileWindow.vue?vue&type=script&lang=js"
export * from "./MobileWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports